module.exports = __webpack_public_path__ + "static/img/05.b1230dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/02/05.jpg
// module id = Brcu
// module chunks = 0